import React from 'react';
import '../../styles/styles.css';

export default function kukke() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/kukke-swamy.jpg" alt="Sri Subrahmanya Swamy" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Important Pooja's to Perform at Kukke Subramanya Temple<br />
    Sarpa Samskara Pooja, Aslesha Bali Pooja<br />    
    <br />

  </strong></p>
  <p>Sarpa Samskara Pooja Temple Booking Service : <a href="https://itms.kar.nic.in/hrcehome/index_temple.php?tid=21" target="_blank" rel="noopener noreferrer">
  Kukke Subrahmanya Official Website
</a>
  </p>
      </div>
            </div>
        </div>

        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/sarpasamskarapooja.jpg" alt="Sri Subrahmanya Swamy" /> 
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2 text-start">
                    <p> <strong>Lord Subrahmanya</strong> resides in this place the in the shape (avatar) of a snake (serpent). This temple complex is located at the foot hills of kumara parvatha and along the banks of river Kumara Dhara. According to mythology, God took birth in the form of Kumara Swamy (the deity) and came with Lord Ganapathi to Kumara Dhara to kill the demon Tarakasura, where he married Devasena (daughter of Devendra) on Margashira Suddha Shashti. He was pleased with the devotion of Nararaju/King of Snakes (“Vasuki”) who was meditating there and assured Vasuki that he will reside with Devasena as a part of divine power. This place is revered to be one of the seven moksha points d by Lord Parashurama. Snake worship (“Nagaradhane”)is being performed since ancient times. It is believed that Vasuki fulfill the requests of devotees with the blessings of Subramanya. This place is also described as Gupta(Meaning: Secret) kshethra. It is the popular belief among devotees visiting the shrine and offering pooja will fulfill their wishes concerning Santhana Bhagya healing of skin disorders and elimination of Nagadosha (curse of the serpent). The soil of the anthill is the Prasadam here. </p><br />
                    <p> <strong>Sarpa Samskara</strong>, Ashlesha Bali and Nagaprathishte are major forms of worship (pooja) held by here. On the of Champa Shasti Mahotsava, the main priest of the temple as part of the worship distributes Mruthike (soil) of anthill. Applying of sandal paste and turmeric paste offering, fried rice, jaggery, banana to the deity is practiced . It is believed that Kumara Dhara river is known for its medical properties and that bathing in the river hake heals skin disorders.</p>
          
      </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box 
        <div className="row mt-3">
            <div className="col-12 Desc-box3">

              <img src="/images/sarpasamskarapooja.jpg" alt="Sri Subrahmanya Swamy" />
             <p>Lord Subrahmanya resides in this place the in the shape (avatar) of a snake (serpent). This temple complex is located at the foot hills of kumara parvatha and along the banks of river Kumara Dhara. According to mythology, God took birth in the form of Kumara Swamy (the deity) and came with Lord Ganapathi to Kumara Dhara to kill the demon Tarakasura, where he married Devasena (daughter of Devendra) on Margashira Suddha Shashti. He was pleased with the devotion of Nararaju/King of Snakes (“Vasuki”) who was meditating there and assured Vasuki that he will reside with Devasena as a part of divine power. This place is revered to be one of the seven moksha points d by Lord Parashurama. Snake worship (“Nagaradhane”)is being performed since ancient times. It is believed that Vasuki fulfill the requests of devotees with the blessings of Subramanya. This place is also described as Gupta(Meaning: Secret) kshethra. It is the popular belief among devotees visiting the shrine and offering pooja will fulfill their wishes concerning Santhana Bhagya healing of skin disorders and elimination of Nagadosha (curse of the serpent). The soil of the anthill is the Prasadam here. Sarpa Samskara, Ashlesha Bali and Nagaprathishte are major forms of worship (pooja) held by here. On the of Champa Shasti Mahotsava, the main priest of the temple as part of the worship distributes Mruthike (soil) of anthill. Applying of sandal paste and turmeric paste offering, fried rice, jaggery, banana to the deity is practiced . It is believed that Kumara Dhara river is known for its medical properties and that bathing in the river hake heals skin disorders.</p>
           </div>
        </div>*/}

        <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Kukke Subramanya Temple Aerial View</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/4GR3kKzjduA?rel=0&modestbranding=1&showinfo=0&controls=0"
                title="Kukke Subramanya Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
    </div>

  )
}
